import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Thu Aug 09 2018
 * @author VBr
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { observable } from 'mobx';
import { BaseStore } from '../BaseStore';
import { StoreName } from '../StoreName';
export var GridStore =
/*#__PURE__*/
function (_BaseStore) {
  _inherits(GridStore, _BaseStore);

  function GridStore() {
    var _this;

    _classCallCheck(this, GridStore);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(GridStore).apply(this, arguments));
    _this.name = StoreName.Grid;
    _this.rowExpansions = new Map();
    return _this;
  }

  return GridStore;
}(BaseStore);

__decorate([observable, __metadata("design:type", Map)], GridStore.prototype, "rowExpansions", void 0);